// 3rd-party
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Stack,
} from "@mui/material";

// Asset components
import tickmark from "../../assets/tickmark.svg";
import all from "../../assets/links/all.png";
import agri from "../../assets/links/agri.png";
import manifacturing from "../../assets/links/manufacturing.png";
import hotels from "../../assets/links/hotels.png";
import csr from "../../assets/links/csr.png";
import water from "../../assets/links/water.png";
import maars from "../../assets/links/itcmaars.png";
import substainability from "../../assets/links/subtainability.png";
import business from "../../assets/links/business.png";

// Config
import { appConfig } from "../../config/appConfig";

// Components
import Spinner from "../spinner/Spinner";

// Services
import { getStorageItemLocal } from "../../services/storageServices";

type LinkGalleryDialogProps = {
  open: boolean;
  onClose: () => void;

  oldMedia?: any;
  setOldMedia?: any;
  oldThumbnail?: any;
  setOldThumbnail?: any;
  gridType?: any;
  setGridType?: any;
  newMedia?: any;
  setNewMedia?: any;
  newThumbnail?: any;
  setNewThumbnail?: any;
  setgridTitle?: any;
  gridTitle?: any;
  editingIndex?: any;
};
type Category = {
  id: number;
  name: string;
  icon: string;
  isActive: boolean;
};

const LinkGalleryDialog: React.FC<LinkGalleryDialogProps> = ({
  open,
  onClose,
  oldMedia,
  setOldMedia,
  oldThumbnail,
  setOldThumbnail,
  gridType,
  setGridType,
  newMedia,
  setNewMedia,
  newThumbnail,
  setNewThumbnail,
  setgridTitle,
  gridTitle,
  editingIndex,
}) => {
  const [dataList, setDataList] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedThumbnail, setSelectedThumbnail] = useState<File[]>([]);

  const [selectgridtitle, setselectgridtitle] = useState<string>("");

  useEffect(() => {
    fetchData();
  }, [editingIndex]);
  useEffect(() => {}, [dataList]);

  useEffect(() => {
    setselectgridtitle(gridTitle);
  }, [gridTitle]);
  const handleSelect = async (option: { name: string; icon: any }) => {
    setselectgridtitle(option.name);

    const iconImg = option.icon as React.ReactElement<{ src: string }>;
    const iconSrc = iconImg.props?.src;

    if (iconSrc) {
      try {
        const response = await fetch(iconSrc);
        const blob = await response.blob();

        const file = new File([blob], `${option.name}.png`, {
          type: blob.type,
        });

        setSelectedThumbnail([file]); // store as array of File (since state is File[])
        // setNewThumbnail([file]); // also update parent state if needed
      } catch (err) {
        console.error("Error converting image to File:", err);
      }
    }
  };

  const linkSelectOption = [
    {
      label: dataList.length > 0 ? dataList[0].name : "ALL",
      icon: (
        <img
          src={dataList.length > 0 ? dataList[0].icon : all}
          alt="all"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "all",
    },
    {
      label: dataList.length > 1 ? dataList[1].name : "Agri",
      icon: (
        <img
          src={dataList.length > 1 ? dataList[1].icon : agri}
          alt="agri"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "agri",
    },
    {
      label: dataList.length > 4 ? dataList[2].name : "CSR",
      icon: (
        <img
          src={dataList.length > 2 ? dataList[2].icon : csr}
          alt="csr"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "csr",
    },
    {
      label: dataList.length > 3 ? dataList[3].name : "Hotels",
      icon: (
        <img
          src={dataList.length > 3 ? dataList[3].icon : hotels}
          alt="visible"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "hotels",
    },
    {
      label: dataList.length > 4 ? dataList[4].name : "ITC Businesses",
      icon: (
        <img
          src={dataList.length > 4 ? dataList[4].icon : business}
          alt="business"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "itcbusinesses",
    },
    {
      label: dataList.length > 5 ? dataList[5].name : "ITC MAARS",
      icon: (
        <img
          src={dataList.length > 5 ? dataList[5].icon : maars}
          alt="maars"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "maars",
    },
    {
      label: dataList.length > 6 ? dataList[6].name : "Manufacturing",
      icon: (
        <img
          src={dataList.length > 6 ? dataList[6].icon : manifacturing}
          alt="manifacturing"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "manufacturing",
    },

    {
      label: dataList.length > 7 ? dataList[7].name : "Sustainability",
      icon: (
        <img
          src={dataList.length > 7 ? dataList[7].icon : substainability}
          alt="substainability"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "sustainability",
    },

    {
      label: dataList.length > 8 ? dataList[8].name : "Water Stewardship",
      icon: (
        <img
          src={dataList.length > 8 ? dataList[8].icon : water}
          alt="water"
          style={{ width: 24, height: 24 }}
        />
      ),
      name: "water",
    },

    ...(dataList.length > 9 && dataList[9].isActive
      ? [
          {
            label: dataList[9].name,
            icon: (
              <img
                src={dataList[9].icon}
                alt="business"
                style={{ width: 24, height: 24 }}
              />
            ),
            name: "category001",
          },
        ]
      : []),

    ...(dataList.length > 10 && dataList[10].isActive
      ? [
          {
            label: dataList[10].name,
            icon: (
              <img
                src={dataList[10].icon}
                alt="category002"
                style={{ width: 24, height: 24 }}
              />
            ),
            name: "category002",
          },
        ]
      : []),

    ...(dataList.length > 11 && dataList[11].isActive
      ? [
          {
            label: dataList[11].name,
            icon: (
              <img
                src={dataList[11].icon}
                alt="category003"
                style={{ width: 24, height: 24 }}
              />
            ),
            name: "category003",
          },
        ]
      : []),
  ];
  const handleAdd = () => {
    setNewThumbnail(selectedThumbnail);
    setGridType("LINK");
    setgridTitle(selectgridtitle);

    handleCancel();
  };
  const handleCancel = () => {
    onClose();
    setSelectedThumbnail([]);
    setselectgridtitle("");
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const tokenString = getStorageItemLocal("token");
      const token = tokenString ? JSON.parse(tokenString) : null;
      const response = await fetch(appConfig.serviceUrls.saveCategory, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) throw new Error("Failed to fetch data");
      const data: Category[] = await response.json();

      setDataList(data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: { width: 1200, height: 400, bgcolor: "#F1F1F1", borderRadius: 2 },
      }}
    >
      <Typography
        sx={{
          color: "#000",
          fontFamily: "Inter",
          fontSize: 34,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          paddingLeft: "40px",
          paddingTop: "35px",
        }}
      >
        Select Icon and add to the Grid
      </Typography>

      {loading ? (
        <>
          {" "}
          <Spinner></Spinner>
        </>
      ) : (
        <>
          <DialogContent
            sx={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              height: "100%",
              padding: "4px",
            }}
          >
            {linkSelectOption.map((option) => {
              const isSelected = selectgridtitle === option.name;
              return (
                <Box
                  key={option.label}
                  onClick={() => handleSelect(option)}
                  sx={{
                    position: "relative",
                    display: "flex",
                    width: 80,
                    height: 90,
                    padding: "20px 57px 20px 53px",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "14px",
                    borderRadius: "12px",
                    border: `2px solid ${isSelected ? "#2E66AB" : "#DCDCDC"}`,
                    background: isSelected ? "#ffffff" : "#e0e0e0",
                    cursor: "pointer",
                    "&:hover": { background: "#DCDCDC" },
                  }}
                >
                  {/* Tick mark overlay tickmark */}
                  {isSelected && (
                    <img
                      src={tickmark}
                      alt="agri"
                      style={{
                        position: "absolute",
                        top: 6,
                        right: 6,
                        color: "#2E66AB",
                        fontSize: 18,
                        width: 24,
                        height: 24,
                      }}
                    />
                  )}
                  {option.icon}
                  <Typography
                    sx={{
                      color: "#000",
                      fontFamily: "Inter",
                      fontSize: 16,
                      fontWeight: 400,
                      textAlign: "center",
                    }}
                  >
                    {option.label}
                  </Typography>
                </Box>
              );
            })}
          </DialogContent>
        </>
      )}

      <Stack
        className="action-button"
        direction="row"
        spacing={2}
        justifyContent="flex-end"
      >
        <Button onClick={handleCancel} className="cancel-button">
          Cancel
        </Button>
        {/* {editingIndex === -1 && ( */}
        <Button onClick={() => handleAdd()} className="save-button">
          Add
        </Button>
        {/* )} */}
      </Stack>
    </Dialog>
  );
};

export default LinkGalleryDialog;
